// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2uYmi","buttons":"PendingPaymentAlert_buttons__h239m"};